var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"has-text-weight-semibold",staticStyle:{"color":"rgb(0, 93, 161)"},attrs:{"to":{ name: _vm.name, params: _vm.params }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }